export default __webpack_public_path__ + "static/media/mockmed_logo.f00d993b.svg";